import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { map, filter, scan, catchError, take, concatMap } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ForbiddenErrorService {

  constructor() { }

  /**
   * Forbiddens error
   * @param errorCode 
   * @returns error 
   */
  forbiddenError(errorCode): string {
    let message = "You don't have rights to access.";

    let errors = Object.keys(ForbiddenError).map(key => ForbiddenError[key]);

    if (errors.some(e => e[0] === errorCode)) {
      let err = errors.find(e => e[0] === errorCode);
      message = err[1];
    }

    return message;
  }

}
/**
 * @ignore
 */
export const ForbiddenError = {
  ERROR_FORBIDDEN: {},
  ERROR_FORBIDDEN_RESOURCE_OWNERSHIP: {},
  ERROR_FORBIDDEN_CUSTOMER_RESOURCE_OWNERSHIP: {},
  ERROR_FORBIDDEN_CUSTOMER_CLIENT_OWNERSHIP: {},
  ERROR_FORBIDDEN_BAD_CREDENTIALS: {},
  ERROR_FORBIDDEN_CLIENT_BACKGROUND_NOT_ASSIGNED: {},
  ERROR_FORBIDDEN_USER_BACKGROUND_NOT_ASSIGNED: {},
  ERROR_FORBIDDEN_EVENT_NOT_ACTIVE: {},
  ERROR_FORBIDDEN_CUSTOMER_INSUFFICIENT_CREDITS: {},
  ERROR_FORBIDDEN_USER_INSUFFICIENT_CREDITS: {},
  ERROR_FORBIDDEN_PRESET_ALREADY_EXISTS: {},
  ERROR_FORBIDDEN_PRESET_IS_NOT_ASSIGNED_TO_USER: {},
  ERROR_FORBIDDEN_FIELD_MODIFICATION: {},
  ERROR_FORBIDDEN_INVALID_PASSWORD: {},
  ERROR_FORBIDDEN_CLIENT_INSUFFICIENT_CREDITS: {},
  ERROR_FORBIDDEN_CANNOT_CREATE_CUSTOMER: {},
  ERROR_FORBIDDEN_CUSTOMER_BACKGROUND_NOT_ASSIGNED: {},
  ERROR_FORBIDDEN_CLIENT_PRESET_NOT_ASSIGNED: {},
  ERROR_FORBIDDEN_CUSTOMER_PRESET_NOT_ASSIGNED: {},
  ERROR_FORBIDDEN_FEATURE_ALREADY_EXISTS: {},
  ERROR_FORBIDDEN_CLIENT_RESOURCE_OWNERSHIP: {},
  ERROR_FORBIDDEN_USER_SETTINGS_MODIFICATION: {},
  ERROR_FORBIDDEN_SAME_IMAGE_POSITION: {},
  ERROR_FORBIDDEN_CUSTOMER_MAXCOUNT_LIMIT: {}
}


ForbiddenError.ERROR_FORBIDDEN = [4030000, 'You don\'t have rights to access.'];
ForbiddenError.ERROR_FORBIDDEN_RESOURCE_OWNERSHIP = [4030001, 'User does not have permission to access this resource'];
ForbiddenError.ERROR_FORBIDDEN_CUSTOMER_RESOURCE_OWNERSHIP = [
  4030002,
  'Customer does not have permission to access this resource',
];
ForbiddenError.ERROR_FORBIDDEN_CUSTOMER_CLIENT_OWNERSHIP = [
  4030003,
  'Customer does not have permission to access this client',
];
ForbiddenError.ERROR_FORBIDDEN_BAD_CREDENTIALS = [4030004, 'Invalid email or password'];
ForbiddenError.ERROR_FORBIDDEN_CLIENT_BACKGROUND_NOT_ASSIGNED = [
  4030005,
  'Client doesn\'t have assigned a speciffic background',
];
ForbiddenError.ERROR_FORBIDDEN_USER_BACKGROUND_NOT_ASSIGNED = [
  4030006,
  'User doesn\'t have assigned a speciffic background',
];
ForbiddenError.ERROR_FORBIDDEN_EVENT_NOT_ACTIVE = [4030007, 'Event is not active'];
ForbiddenError.ERROR_FORBIDDEN_CUSTOMER_INSUFFICIENT_CREDITS = [
  4030008,
  'Customer does not have enough credits. Please add more or contact support.',
];
ForbiddenError.ERROR_FORBIDDEN_USER_INSUFFICIENT_CREDITS = [
  4030009,
  'User does not have enough credits. Please contact support.',
];
ForbiddenError.ERROR_FORBIDDEN_PRESET_ALREADY_EXISTS = [4030010, 'Preset :name already exists'];
ForbiddenError.ERROR_FORBIDDEN_PRESET_IS_NOT_ASSIGNED_TO_USER = [
  4030011,
  'Preset is not assigned to user',
];
ForbiddenError.ERROR_FORBIDDEN_FIELD_MODIFICATION = [
  4030012,
  'You can\'t update filds',
  'Logged in user does not have permissions to update following filds: :fields',
];
ForbiddenError.ERROR_FORBIDDEN_INVALID_PASSWORD = [4030013, 'Password is not correct'];
ForbiddenError.ERROR_FORBIDDEN_CANNOT_CREATE_CUSTOMER = [4030014, 'Customer :customerId cannot create other customers'];
ForbiddenError.ERROR_FORBIDDEN_CUSTOMER_BACKGROUND_NOT_ASSIGNED = [
  4030015,
  'Customer :customerId does not have assigned background :backgroundId',
];
ForbiddenError.ERROR_FORBIDDEN_PRESET_IS_NOT_ASSIGNED_TO_USER = [
  4030016,
  'Preset is not assigned to user',
];
ForbiddenError.ERROR_FORBIDDEN_CLIENT_PRESET_NOT_ASSIGNED = [
  4030017,
  'Client :clientId does not have assigned preset :presetId',
];
ForbiddenError.ERROR_FORBIDDEN_CUSTOMER_PRESET_NOT_ASSIGNED = [
  4030018,
  'Customer :customerId does not have assigned preset :presetId',
];
ForbiddenError.ERROR_FORBIDDEN_FEATURE_ALREADY_EXISTS = [4030019, 'Feature already exists'];
ForbiddenError.ERROR_FORBIDDEN_CLIENT_RESOURCE_OWNERSHIP = [
  4030020,
  'Client does not have permission to access this resource',
];
ForbiddenError.ERROR_FORBIDDEN_CLIENT_INSUFFICIENT_CREDITS = [
  4030021,
  'Client does not have enough credits. Please add more or contact support.',
];
ForbiddenError.ERROR_FORBIDDEN_CLIENT_RESOURCE_OWNERSHIP = [
  4030022,
  'Client does not have permission to access this resource',
];
ForbiddenError.ERROR_FORBIDDEN_USER_SETTINGS_MODIFICATION = [4030023, 'Client disallowed modifying user settings'];
ForbiddenError.ERROR_FORBIDDEN_SAME_IMAGE_POSITION = [4030031, 'Cannot restore because vehicle has undeleted image on selected position'];
ForbiddenError.ERROR_FORBIDDEN_CUSTOMER_MAXCOUNT_LIMIT = [4030050, 'Customer admin can only set the limit between 0 and 12.'];